import { isProd, isTest } from "./env";

/* eslint-disable no-unused-vars */
export const devLog = (...args) => {
  if (!isProd() && !isTest()) {
    // console.log(...args);
  }
};

export const devWarn = (...args) => {
  if (!isProd() && !isTest()) {
    // console.warn(...args);
  }
};
